import { ErrorComponent, type ErrorComponentProps } from '@tanstack/react-router';

export function ErrorBoundary({ error }: ErrorComponentProps) {
    return <ErrorComponent error={error} />;
}
